/**
 * Check if Rich Text is filled in, otherwise Kontent returns a value '<p><br></p>'
 */
const isRichTextValid = (value: string): boolean => Boolean(value) && value !== '<p><br></p>';

export default isRichTextValid;
